const vm = {
    "vm.title.block1": "Virtual",
    "vm.title.block2": "Mirror",
    "vm.defineClassic": "Define® Classic",
    "vm.defineFresh": "Define® Fresh",
    "vm.learnmore": "Learn More",
    "vm.shownow": "Shop Now",
}

export default vm;